import type { Special, NewsItem } from "@/types/film";

export const specials: Special[] = [
  {
    id: "rain-and-neon",
    title: "雨夜与霓虹",
    subtitle: "韩式悬疑的气质样本",
    intro:
      "从一场雨、一条巷子、一盏不肯熄灭的灯开始，韩国悬疑作品总能把城市拍成一座有情绪的建筑。这组合集挑出六部在氛围营造上极具代表性的作品，适合深夜独自观看。",
    reason:
      "这六部作品的共同点不是案件多复杂，而是它们都愿意花时间拍「等待」：等一个人出现，等一通电话，等雨停。看完之后，你会开始注意自己城市里那些被忽略的角落。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20moody%20Korean%20noir%20collage%20scene%2C%20rain%20slicked%20Seoul%20street%20with%20glowing%20amber%20and%20teal%20neon%20reflections%2C%20silhouette%20under%20a%20transparent%20umbrella%2C%20misty%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20no%20text%2C%20editorial%20film%20photography%20with%20rich%20shadow%20detail&width=1200&height=675&seq=special-rain-neon&orientation=landscape",
    filmIds: ["seoul-night-rain", "white-night-chase", "train-in-fog", "silent-testimony", "platform-seven", "deep-sea-echo"],
  },
  {
    id: "joseon-light",
    title: "古装美学",
    subtitle: "朝鲜时代的光影与笔墨",
    intro:
      "宫墙、纸窗、墨迹与烛火，古装作品的魅力往往藏在极慢的细节里。这组合集聚焦以文戏与美术见长的作品，服装、器物与光线都值得单独暂停欣赏。",
    reason:
      "它们讲的其实都是同一件事：一个人如何在巨大的规则里保住自己的判断。《王的画师》与《光化门往事》尤其适合对照观看，一部讲画笔，一部讲史笔。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20Korean%20historical%20palace%20interior%20at%20dusk%2C%20paper%20screen%20doors%20with%20warm%20candlelight%2C%20ink%20brush%20and%20scroll%20on%20a%20low%20wooden%20table%2C%20deep%20indigo%20shadows%20and%20amber%20highlights%2C%20painterly%20cinematic%20composition%2C%20no%20text%2C%20museum%20quality%20detail&width=1200&height=675&seq=special-joseon-light&orientation=landscape",
    filmIds: ["king-painter", "gwanghwamun-days", "last-kimchi", "my-name-is-star"],
  },
  {
    id: "warm-spring-list",
    title: "春日治愈清单",
    subtitle: "适合周末下午的三部曲",
    intro:
      "如果最近有点累，这组作品可以当作一次情绪上的休息。没有强冲突，没有反派，只有做饭、聊天、在巷子里慢慢走路的人。",
    reason:
      "建议按《春日便当店》→《三清洞的猫》→《济州岛的春天》的顺序观看，从饱腹到放松，再到一点点怅然，刚好是一个完整的下午。",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20warm%20Korean%20healing%20scene%2C%20sunlit%20courtyard%20of%20a%20small%20old%20Seoul%20house%20with%20potted%20plants%2C%20steaming%20tea%20and%20a%20bento%20box%20on%20a%20wooden%20table%2C%20dappled%20afternoon%20light%2C%20cream%20and%20terracotta%20palette%2C%20no%20text%2C%20gentle%20editorial%20photography&width=1200&height=675&seq=special-warm-spring&orientation=landscape",
    filmIds: ["spring-bento", "samcheong-cat", "jeju-spring", "han-river-winter"],
  },
  {
    id: "family-table",
    title: "一张饭桌",
    subtitle: "韩式家庭剧的情感现场",
    intro:
      "在韩国影视里，饭桌几乎从不只是吃饭的地方。谁坐哪里、谁先动筷、谁沉默，都是一场没有台词的对话。这组作品把镜头对准家庭，也把镜头对准我们自己的餐桌。",
    reason:
      "从《汉江之冬》的克制，到《最后的泡菜》的热闹，四部作品展示了家庭叙事的四种温度。看完不妨给家里打个电话，趁汤还没凉。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20family%20dinner%20table%20seen%20from%20above%2C%20many%20small%20dishes%20and%20steaming%20soup%2C%20hands%20reaching%20with%20chopsticks%2C%20warm%20amber%20lamp%20light%20against%20deep%20blue%20evening%20window%2C%20tender%20nostalgic%20mood%2C%20no%20text%2C%20cinematic%20food%20photography&width=1200&height=675&seq=special-family-table&orientation=landscape",
    filmIds: ["han-river-winter", "last-kimchi", "my-name-is-star", "reverse-life"],
  },
];

export const news: NewsItem[] = [
  {
    id: "news-01",
    title: "《无声证词》收官：手语庭审戏为何被称为年度最佳片段",
    date: "2025-10-12",
    category: "剧情解析",
    excerpt:
      "最后一集的法庭戏几乎没有配乐，全靠手语与呼吸完成叙事。我们拆解了这场戏如何用一个长镜头，把「被听见」这件事讲透。",
  },
  {
    id: "news-02",
    title: "《第七号月台》时间线整理：三次上车分别改写了什么",
    date: "2025-10-06",
    category: "深度解读",
    excerpt:
      "同一段月台在片中出现了九次，每次的时钟、灯光与行李都不同。按时间顺序重排之后，故事其实还有另一种读法。",
  },
  {
    id: "news-03",
    title: "《三清洞的猫》更新至第12集：一条巷子的完整人情图鉴",
    date: "2025-10-15",
    category: "更新速报",
    excerpt:
      "本集终于交代了书店老板的来历，也让橘猫的巡街路线完成闭环。结尾那句「它今天来了两次」被观众反复截图。",
  },
  {
    id: "news-04",
    title: "从《首尔夜雨》看雨戏的拍法：潮湿如何成为叙事工具",
    date: "2025-09-20",
    category: "镜头笔记",
    excerpt:
      "雨不只是气氛。灯光在积水里的反射方向，决定了观众能不能看清人物的脸。这篇笔记聊了聊片中三场关键雨戏的打光设计。",
  },
  {
    id: "news-05",
    title: "古装剧美术特辑：一间画室是如何被搭出来的",
    date: "2025-09-02",
    category: "幕后",
    excerpt:
      "从纸窗的透光率到墨汁的浓淡，剧组用两个月复原了一间能真正画画的宫廷画室。我们整理了美术组分享的六组细节。",
  },
  {
    id: "news-06",
    title: "本周片单：五部适合在秋天重看的韩国电影",
    date: "2025-08-28",
    category: "片单推荐",
    excerpt:
      "天气转凉之后，有些电影会更好看。这五部作品的共同点是：它们都不急着讲完一个故事，而是留了足够的空间给你走神。",
  },
];